import React, { useEffect } from 'react';
import Layout from '../components/layout';
import { navigate } from 'gatsby-link';

export default () => {
  const browser = typeof window !== 'undefined';

  useEffect(() => {
    setTimeout(() => {
      navigate('/');
    }, 5000);
  }, []);

  return browser && <Layout>Not found</Layout>;
};
